import { useMutation } from 'react-query';
import axios from 'axios';
import { TerminalAppearanceAPI } from '../../../constants/API';
import { queryClient } from '../../../queryClient';
import { multipartHeaders } from '../../../constants/HeadersAPI';
import { useContext } from 'react';
import { AlertContext } from '../../../context/AlertProvider';
import { AlertType } from '../../../types/enums';
import { defaultSuccessMessage } from '../../../constants/alertText';

export const usePostTerminalBackground = () => {
  const context = useContext(AlertContext);

  const { mutate: uploadTerminalBackground, isLoading: isUploadTerminalBackgroundLoading } =
    useMutation(
      ['TerminalAppearanceUploadBackground'],
      (file: File) => {
        const formData = new FormData();
        formData.append('file', file);
        return axios.post(TerminalAppearanceAPI.uploadBackground, formData, multipartHeaders());
      },
      {
        onSuccess: () => {
          queryClient
            .invalidateQueries('TerminalAppearance')
            .then(() =>
              context?.setAlert({ type: AlertType.Success, message: defaultSuccessMessage })
            );
        }
      }
    );

  return { uploadTerminalBackground, isUploadTerminalBackgroundLoading };
};
